/*
    Add class 'scroll' to body tag when scroll
*/
document.addEventListener("DOMContentLoaded", function () {
    const scrollElementQuery = 'body';
    const targetElementQuery = 'body';
    const scrollClass = 'scroll';
    const bodyHsClass = 'hs-body';

    const scrollElement = document.querySelector(scrollElementQuery);
    const targetElement = document.querySelector(targetElementQuery);
    let scrollElementPos = document.body.scrollTop || document.documentElement.scrollTop;

    if (targetElement && scrollElement.classList.contains(bodyHsClass)) {
        if (scrollElementPos >= 1) {
            targetElement.classList.add(scrollClass);
        }
        document.addEventListener('scroll', (event) => {
            scrollElementPos = document.body.scrollTop || document.documentElement.scrollTop;

            if (scrollElementPos >= 24) {
                targetElement.classList.add(scrollClass);
            }
            else {
                targetElement.classList.remove(scrollClass);
            }
        });
    }
});


document.addEventListener("DOMContentLoaded", function () {
    var banner = document.getElementById("top-header");
    var button = document.getElementById("top-header-button");
    function isOverflowed(element) {
        return element.scrollWidth > element.clientWidth;
    }

    function checkOverflow() {
        if (banner && button) {
            var paragraphs = banner.getElementsByTagName("p");
            var overflowed = false;

            for (var i = 0; i < paragraphs.length; i++) {
                if (isOverflowed(paragraphs[i])) {
                    overflowed = true;
                    break;
                }
            }

            if (overflowed) {
                button.classList.add("active");
            } else {
                button.classList.remove("active");
            }
        }
        
    }

    // Initial check
    checkOverflow();

    // Check overflow on window resize
    window.addEventListener("resize", checkOverflow);
});

